<template>
  <v-card>
    <div class="my-card-title-wrapper">
      <div class="my-card-title">
        <v-icon
          medium
          :color="$vuetify.theme.primary"
        >
          {{icon}}
        </v-icon>
        &nbsp;
        <span class="title">
          {{title}}
        </span>
      </div>
    </div>
    <v-card-text>
      <v-layout row wrap>
        <slot></slot>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.my-card-title-wrapper {
  padding: 16px 16px 0;
  .my-card-title {
    display: flex;
    align-items: center;
    color: var(--v-primary-base);
  }
}
</style>
